<nz-card class="header-card" nzSize="small" >
  <div class="flex justify-start flex-wrap gap-0 xsm:gap-2" >
    <app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
  </div>
  <div class="flex justify-between my-3">
    <h2 class="!text-lg xxsm:!text-2xl my-0">Articles</h2>
  </div>
</nz-card>

<nz-card class="!my-4" >
  <div class="max-w-[600px] w-[100%]" >
    <nz-input-group nzSearch nzSize="large"  [nzSuffix]="inputClearTpl" [nzAddOnAfter]="suffixIconButton" style="max-width: 500px">
      <input type="text"  nz-input placeholder="Search Articles" [(ngModel)]="searchValue"/>
    </nz-input-group>
    <ng-template #suffixIconButton>
      <button nz-button nzType="primary" (click)="getArticlesBySearch()" nzSearch><span nz-icon nzType="search"></span>Search</button>
    </ng-template>
    <ng-template #inputClearTpl>
      <span
        nz-icon
        class="ant-input-clear-icon"
        nzTheme="fill"
        nzType="close-circle"
        *ngIf="searchValue"
        (click)="cancelSearch()"
      ></span>
    </ng-template>
  </div>
</nz-card>
<nz-empty class="mt-10" *ngIf="this.data.length === 0"></nz-empty>
<div class="mt-4 grid-container" >

  <div class="bg-white px-3 2xl:px-5 rounded-md relative py-5" *ngFor="let article of this.data" >
    <a (click)="navToSingle(article)">
    <div class="flex justify-between items-center gap-4 flex-col xl:flex-row" >
      <div class="basis-[40%]  w-full h-[250px]"  >
        <img class="w-full h-full object-cover rounded-md" alt="Image" (error)="onImageError($event)" [src]="article.thumbnail.url"/>
      </div>
      <div class="basis-[60%] w-full text-left" >
        <h4 >{{article.name}}</h4>
        <h6 class="text-[#959595]" >{{article.author}}</h6>
        <p class="my-4 font-[400]" >{{this.article.excerpt}}</p>
      </div>
    </div>
    </a>
  </div>
</div>

<div class="mt-4 flex justify-end" >
  <nz-pagination class="mt-8" (nzPageIndexChange)="onCurrentPageDataChange($event)" [nzPageIndex]="currentPage" [nzTotal]="totalDocs" [nzPageSize]="pageSize"></nz-pagination>
</div>
